var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6121 20.2911L15.7987 15.594H8.19759L3.38408 20.2911L5.64264 22.4951L10.4561 17.7979C10.8688 17.3953 11.4129 17.1755 11.9982 17.1755C12.5834 17.1755 13.1274 17.3953 13.5401 17.7979L18.3536 22.4951L20.6121 20.2911Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6016 14.2395L23.1746 15.9565L24 12.9435L17.4269 11.2264C16.8642 11.08 16.3952 10.7285 16.1025 10.2343C15.8099 9.74366 15.7349 9.1689 15.885 8.61976L17.6445 2.20558L14.5568 1.40015L12.7973 7.81432L16.5978 14.2359L16.6016 14.2395Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.825387 15.9565L7.39847 14.2395L7.40222 14.2359L11.2027 7.81432L9.44319 1.40015L6.35548 2.20558L8.11505 8.61976C8.26512 9.1689 8.19009 9.74366 7.89745 10.2343C7.60481 10.7285 7.13585 11.08 6.57308 11.2264L0 12.9435L0.825387 15.9565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract);
export default __webpack_public_path__ + "static/media/abstract.af658014028ba98fe585ea0063af74aa.svg";
export { ForwardRef as ReactComponent };